




































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Error404Page',
  mounted: function() {
    this.setPageTitle({ title: 'Page not found', visible: false });
  },
  methods: {
    ...mapActions(['setPageTitle']),
    ...mapGetters({
      isUserLoggedIn: 'isUserLoggedIn',
    }),
    navigateBack() {
      window.history.go(-1);
    },
  },
});
